import { getJson, postJson } from './client'
import type { JobView } from '../types/voice'
import type { WeeklyUpdateSummary, WeeklyView } from '../types/weekly'

// The weekly update: the week's movement (computed by the API against the last written update), the stored
// narrative, and the week ahead. Writing a week is the weekly-write job.
const weekly = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/weekly`

export const weeklyApi = {
  /** `week` is any day (YYYY-MM-DD) naming its Monday-to-Sunday week; omitted = this week. */
  view: (spoke: string, week?: string) => getJson<WeeklyView>(weekly(spoke), week ? { week } : undefined),
  write: (spoke: string, week?: string) => postJson<JobView>(`${weekly(spoke)}/write${week ? `?week=${encodeURIComponent(week)}` : ''}`, {}),
  history: (spoke: string, take = 26) => getJson<WeeklyUpdateSummary[]>(`${weekly(spoke)}/history`, { take }),
}
